(() => {
  if (customElements.get('cfa-bat-preparation')) return;

  class CfaBatPreparation extends HTMLElement {
    connectedCallback() {
      const checkbox = this.querySelector('[data-free-knock-in]');
      const form = document.getElementById(this.dataset.formId);
      if (!checkbox || !form) return;
      // The product form survives variant rerenders; retain the shopper's choice there.
      checkbox.checked = form.dataset.cfaFreeKnockIn === 'true';
      checkbox.addEventListener('change', () => {
        form.dataset.cfaFreeKnockIn = String(checkbox.checked);
      });
    }
  }

  customElements.define('cfa-bat-preparation', CfaBatPreparation);
})();
